import { css } from '@emotion/react';
import { PaymentPlanSummary } from '@frontend/api-payment-plans';
import { useTranslation } from '@frontend/i18n';
import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';
import { SummaryItem } from '../../SummaryItem';

export interface PaymentPlanSummaryCardProps {
  summary?: PaymentPlanSummary;
  loading: boolean;
  displayDateLabel?: string;
}

export const PaymentPlanSummaryCard = ({ summary, loading, ...rest }: PaymentPlanSummaryCardProps) => {
  const { t } = useTranslation('payments');
  const isMobile = useMatchMedia({ maxWidth: breakpoints.small.min });

  return (
    <>
      <div
        css={css`
          @media (min-width: ${breakpoints.small.min}px) {
            padding-top: ${theme.spacing(2)};
          }
        `}
        {...rest}
      >
        <div
          css={css`
            display: flex;
            flex-direction: row;
            justify-content: flex-sart;
            flex-wrap: wrap;
            gap: ${theme.spacing(2, 4)};
            ${isMobile &&
            `
              background-color: ${theme.colors.neutral5};
              padding: ${theme.spacing(2, 3)};
              border: 1px solid ${theme.colors.neutral20};
              border-left: none;
              border-right: none;
            `}
          `}
        >
          <SummaryItem
            label={t('Total Plans')}
            amount={summary?.totalPlans}
            loading={loading}
            isAmountValue={false}
            data-trackingid='pay-portal-payment-plans-btn-totalplanshint'
          />
          <SummaryItem
            label={t('Expected Payments')}
            amount={summary?.expectedPayments}
            loading={loading}
            data-trackingid='pay-portal-payment-plans-btn-expectedpaymentshint'
          />
          <SummaryItem
            label={t('Outstanding Balance')}
            amount={summary?.outstandingBalance}
            loading={loading}
            data-trackingid='pay-portal-payment-plans-btn-outstandingbalancehint'
          />
          <SummaryItem
            label={t('Past Due')}
            amount={summary?.missedPayments ?? 0}
            loading={loading}
            data-trackingid='pay-portal-payment-plans-btn-missedpaymentshint'
          />
        </div>
      </div>
    </>
  );
};
